import React from 'react';
import { LinkModel } from '../Types/LinkModel';

interface ListBlockHeaderProps {
  preTitle?: string;
  title?: string;
  link?: LinkModel;
}

const ListBlockHeader = ({
  preTitle,
  title,
  link,
}: ListBlockHeaderProps) => {
  return (
    <div className="mb-4 flex items-center justify-between">
      <div>
        {preTitle && (
          <span className="pretitle-sm mb-3 inline-block">{preTitle}</span>
        )}
        {title && <h2 className="font-normal">{title}</h2>}
      </div>

      <div className="flex items-center self-end">
        {link?.href && (
          <a
            href={link.href}
            className="group relative block overflow-hidden whitespace-nowrap pb-[1px] text-md leading-tight text-gray-700 store-screen:border-b store-screen:border-gray-900"
          >
            {link.text}
            <span className="absolute bottom-0 left-0 h-[1px] w-full bg-gray-700 transition-[left] duration-700 group-hover:left-[200%] store-screen:hidden"></span>
            <span className="absolute -left-[200%] bottom-0 h-[1px] w-full bg-gray-700 transition-[left] duration-700 group-hover:left-0 store-screen:hidden"></span>
          </a>
        )}
      </div>
    </div>
  );
};

export default ListBlockHeader;
